import { ActionButtons } from '../ActionButtons';
import { Box } from '../Box';
import { idBuilder } from '../internal';
import { clsx } from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
export const FixedFooter = props => {
  const {
    footer,
    hasOverflow,
    size,
    id,
    options,
    customIdentifiers = {},
    ...rest
  } = props;
  if (size === 'largeOnXS' && !hasOverflow) {
    return null;
  }
  if (!footer) {
    return null;
  }
  if (footer.footerComponent) {
    return /*#__PURE__*/_jsx(Box, {
      className: 'ids-modal-fixed-footer-component',
      id: customIdentifiers['footer']?.id || idBuilder('ids-modal-fixed-footer-component', id),
      "data-testid": customIdentifiers['footer']?.dataTestId || idBuilder('ids-modal-fixed-footer-component', rest['data-testid']),
      children: footer.footerComponent
    });
  }
  if (!footer.primary) {
    return null;
  }
  if (size === 'largeOnXS') {
    return /*#__PURE__*/_jsx(Box, {
      position: 'absolute',
      bottom: '0',
      right: '0',
      width: '100%',
      className: clsx(['ids-modal-footer', 'ids-modal-fixed-overflow-footer']),
      id: customIdentifiers['footer']?.id || idBuilder('ids-modal-footer', id),
      "data-testid": customIdentifiers['footer']?.dataTestId || idBuilder('ids-modal-footer', rest['data-testid']),
      children: /*#__PURE__*/_jsx(ActionButtons, {
        size: 'medium',
        primary: footer?.primary,
        options: options,
        overflow: true,
        layout: footer?.xsLayout,
        id: id,
        "data-testid": rest['data-testid'],
        customIdentifiers: customIdentifiers
      })
    });
  }
  return /*#__PURE__*/_jsx(Box, {
    className: clsx(['ids-modal-footer', 'ids-modal-fixed-footer']),
    id: customIdentifiers['footer']?.id || idBuilder('ids-modal-footer', id),
    "data-testid": customIdentifiers['footer']?.dataTestId || idBuilder('ids-modal-footer', rest['data-testid']),
    padding: size === 'small' ? '20px 24px 24px 24px' : '20px 32px 32px 32px',
    children: /*#__PURE__*/_jsx(ActionButtons, {
      size: size === 'small' ? 'small' : 'medium',
      primary: footer?.primary,
      options: options,
      overflow: false,
      layout: size !== 'small' ? footer?.layout : 'rightAligned',
      id: id,
      "data-testid": rest['data-testid'],
      customIdentifiers: customIdentifiers
    })
  });
};